import {barnManagerModule} from '../../index.module';
import {downgradeInjectable} from '@angular/upgrade/static';
import {MatDialog} from '@angular/material/dialog';

barnManagerModule.factory('ng2MatDialog', downgradeInjectable(MatDialog));
